import HapticsButtonWrapper from "@Components/generic/haptics-button-wrapper";
import Icon from "@Components/generic/icon";
import { faArrowAltCircleRight, IconDefinition } from "@fortawesome/pro-solid-svg-icons";
import { ButtonBase, Stack, SxProps, Typography, useTheme } from "@mui/material";

// Swiper styles
import "swiper/css";
import "swiper/css/free-mode";

interface INavSection {
  children: React.ReactNode;
  title: string;
  navText?: string;
  icon?: IconDefinition;
  sx?: SxProps;
  headerSx?: SxProps;
}

const NavSection = ({ children, title, navText, icon, sx, headerSx }: INavSection) => {
  const theme = useTheme();
  return (
    <Stack spacing={3} sx={sx}>
      <Stack direction="row" sx={{ justifyContent: "space-between" }}>
        <Stack direction="row" spacing={2} sx={headerSx}>
          {icon && <Icon icon={icon} color={theme.palette.dsNeutral.v300} fontSize={24} />}
          <Typography variant="text2xl700" color="dsBase.v200">
            {title}
          </Typography>
        </Stack>
        {navText && (
          <HapticsButtonWrapper>
            <ButtonBase onClick={() => {}} disableRipple>
              <Stack direction="row" spacing={1.5} alignItems="center">
                <Typography variant="textBase700" color="dsPrimary.v300">
                  {navText}
                </Typography>
                <Icon icon={faArrowAltCircleRight} size="2x" color={theme.palette.dsPrimary.v300} />
              </Stack>
            </ButtonBase>
          </HapticsButtonWrapper>
        )}
      </Stack>
      {children}
    </Stack>
  );
};

export default NavSection;
